'use strict';

import PropTypes from 'prop-types';

import React from 'react';
import classNames from 'classnames';

const VideoProgress = ({ percent, hidden }) => {
    if (!percent) {
        return null;
    }

    const className = classNames('play_video-progress', {
        'play_is--inactive': percent === 0,
        'play_is--hidden': hidden,
    });

    return (
        <span
            className={className}
            role="progressbar"
            aria-label="Förloppsindikator"
            aria-valuetext={`Du har sett ${Math.round(percent)}% av programmet`}
            aria-valuemin="0"
            aria-valuemax="100"
            aria-valuenow={percent}
        >
            <div className="play_video-progress__value" style={{ width: percent + '%' }}></div>
        </span>
    );
};

VideoProgress.propTypes = {
    percent: PropTypes.number,
};

export default VideoProgress;
